import type {
  U3121BillingProjectProfitabilityMode,
  U3121BillingProjectProfitabilityStatus,
} from "../../../../U3121Service";

export function u3121ProfitabilityStatusBadgeClass(status: U3121BillingProjectProfitabilityStatus): string {
  switch (status) {
    case "profitable":
      return "bg-emerald-100 text-emerald-900";
    case "at_risk":
      return "bg-amber-100 text-amber-900";
    case "unprofitable":
      return "bg-rose-100 text-rose-900";
    default:
      return "bg-slate-200 text-slate-800";
  }
}

export function u3121ProfitabilityProgressBarClass(status: U3121BillingProjectProfitabilityStatus): string {
  switch (status) {
    case "profitable":
      return "bg-emerald-500";
    case "at_risk":
      return "bg-amber-500";
    case "unprofitable":
      return "bg-rose-500";
    default:
      return "bg-slate-400";
  }
}

export function u3121ProfitabilityStatusMessageKey(status: U3121BillingProjectProfitabilityStatus): string {
  switch (status) {
    case "profitable":
      return "profitabilityStatusProfitable";
    case "at_risk":
      return "profitabilityStatusAtRisk";
    case "unprofitable":
      return "profitabilityStatusUnprofitable";
    case "insufficient_data":
      return "profitabilityStatusInsufficientData";
    default:
      return "profitabilityStatusNotApplicable";
  }
}

export function u3121ProfitabilityModeMessageKey(mode: U3121BillingProjectProfitabilityMode): string | null {
  if (mode === "FIXED_FEE") return "profitabilityModeFixedFee";
  if (mode === "TIME_AND_MATERIAL") return "profitabilityModeTimeAndMaterial";
  return null;
}

export function u3121FormatPercent(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${value.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`;
}

export function u3121FormatMultiplier(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return `×${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function u3121ProfitabilityProgressPercent(costConsumedPercent: number | null | undefined): number {
  if (costConsumedPercent == null || !Number.isFinite(costConsumedPercent)) return 0;
  return Math.min(100, Math.max(0, costConsumedPercent));
}
